import { useState } from 'react';

import NextImage from '@/components/NextImage';
import styles from './index.module.scss';
import classNames from 'classnames';
import { useGlobal } from '@/utils/useGlobal';
import gtm from 'eco-design-reliance/gtm';
import { zhCnOrderLink } from '@elem/compPage/Powerocean';
import SubtractBlack from '@elem/compPage/Powerocean/components/svg/SubtractBlack';
import EcoDialogVideo from 'eco-design/elements/eco-dialog-video';

export default function FirstKV() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanPlus.FirstKV');

    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const handleVideoPlay = () => {
        setShowEFVideoModal(true);
    };
    const handleJump = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'select_banner',
            banner_name: t('title'),
            position: 'banner_1',
            button_name: t('btn2'),
        });

        window.open(zhCnOrderLink, '_blank');
    };

    return (
        <div className={classNames(styles.firstKV)}>
            <div className="bg-img">
                <NextImage src="https://ecoflow-service-eu-cdn.ecoflow.com/upload/image/1718676375356/pc-tuya.jpg" alt={t('title')} />
            </div>
            <div className="bg-img-h5">
                <NextImage src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717575909938/mo-tuya.jpg" alt={t('title')} />
            </div>
            <div className="text-box">
                <h1 className="title">{t('title')}</h1>
                <h1 className="title-h5">{t('title')}</h1>
                <h2 className="sub-title">{t('desc')}</h2>
                <div className="btn-box">
                    <div className="video-btn" onClick={handleVideoPlay}>
                        {t('btn1')}
                        <SubtractBlack className="video-icon" />
                    </div>
                    <div className="jump-btn" onClick={handleJump}>
                        {t('btn2')}
                    </div>
                </div>
            </div>

            <EcoDialogVideo
                open={showEFVideoModal}
                src={'https://websiteoss.ecoflow.com/upload/video/1767079088203/homebattery-CN.mp4'}
                callback={() => setShowEFVideoModal(false)}
            />
        </div>
    );
}
